import React, { useContext } from 'react';

import { DealContext } from '../context';

import InfoTab from 'views/paulAu/deals/tabs/InfoTab'
import DocumentTab from 'views/paulAu/deals/tabs/DocumentTab'
import UploadTab from 'views/paulAu/deals/tabs/UploadTab'
import NoteTab from 'views/paulAu/deals/tabs/NoteTab'
import TaskTab from 'views/paulAu/deals/tabs/TaskTab'

export default function Content() {
  const dealContext = useContext(DealContext);
  const {
    tab
  } = dealContext;
  return (
    <>
      {tab == 'info' && <InfoTab />}
      {tab == 'documents' && <DocumentTab />}
      {tab == 'uploads' && <UploadTab />}
      {tab == 'notes' && <NoteTab />}
      {tab == 'tasks' && <TaskTab />}
    </>
  );
}